import product from './product'
import productSettings from './productSettings'

export default [
  ...product,
  ...productSettings,
]
